/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T15:54:15.665
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentChannelApply,
	getRentChannelApplyCreateInit,
	getRentChannelApplyEditInit,
	getRentChannelApplyView,
	deleteRentChannelApply,
	startWorkflow
} from '@api/rentmanage/RentChannelApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listRentChannelApplyItemInit,
listRentChannelApplyItemByAuthorizations,
deleteRentChannelApplyItem
} from '@api/rentmanage/RentChannelApplyItem';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentChannelApplyCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		startWorkflow({}, RentChannelApply) {
			return new Promise((resolve, reject) => {
				startWorkflow(RentChannelApply)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentChannelApplyEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentChannelApply({}, RentChannelApply) {
			return new Promise((resolve, reject) => {
				saveRentChannelApply(RentChannelApply)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentChannelApplyView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentChannelApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentChannelApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
